import TopBar from '../topBar/TopBar';
import RaptorSnackbar from '../../feedback/raptorSnackbar/Snackbar.component';
import { mainColors } from '../../../styling/theme';
import SettingsMenu from '../settingsMenu/SettingsMenu.component';
import makeStyles from '@mui/styles/makeStyles';
import { Outlet } from 'react-router-dom';

import AuthenticatedPage from '../../../routes/utils/AuthenticatedPage';

const useStyles = makeStyles({
  body: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: mainColors.background,
  },
  main: {
    height: 'calc(100% - 3.75rem)',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  content: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
    padding: '0.62rem',
  },
});

const SettingsLayout = () => {
  const classes = useStyles();

  return (
    <div className={classes.body}>
      <TopBar />
      <main className={classes.main}>
        <SettingsMenu />
        <div className={classes.content}>
          <AuthenticatedPage Component={Outlet} hardSection="settings" />
        </div>
      </main>
      <RaptorSnackbar />
    </div>
  );
};

export default SettingsLayout;
